import { Helmet } from "react-helmet-async";

const SITE = "UKJobLots.co.uk";
const DEFAULT_DESC = "Members-only UK job lots, pallets and clearance stock direct from retailers. One deal a day — gone when it's gone. Join free to unlock trade prices.";

export const SEO = ({ title, description = DEFAULT_DESC, image = "/logo.png", jsonLd }) => (
  <Helmet>
    <title>{title ? `${title} | ${SITE}` : `${SITE} — One Deal A Day. Gone When It's Gone.`}</title>
    <meta name="description" content={description} />
    <meta property="og:title" content={title || SITE} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={image} />
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content={SITE} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title || SITE} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image} />
    {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
  </Helmet>
);
